import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Grid } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import TablePagination from '@mui/material/TablePagination';
import { useState } from 'react';
import PaymentDialog from './PaymentDialog';
import { GetPaymentStatus } from 'API/DsPaymentLink/api';
import RemarksDialog from './RemarksDialog';

const DsPaymentLinkTable = (props) => {
  const [OpenPaymentDialog, setOpenDialog] = useState(false);
  const [SelectedId, setSelectedId] = useState(null);
  const [SelectedItem, setSelectedItem] = useState(null);
  const [OpenReview, setOpenReview] = useState(false);

  const handleOpenReview = (row) => {
    setSelectedItem(row);
    setOpenReview(true);
  };

  const handleCloseReview = () => {
    setOpenReview(false);
  };

  const handlePaymentOpen = (id) => {
    setOpenDialog(true);
    setSelectedId(id);
  };

  const handlePaymentClose = () => {
    setOpenDialog(false);
  };

  const CheckPaymentStatus = (id) => {
    GetPaymentStatus(id, props.setIsLoading, props.handleAlertOpen);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <MainCard>
          <RemarksDialog open={OpenReview} handleClose={handleCloseReview} data={SelectedItem} />
          <PaymentDialog
            open={OpenPaymentDialog}
            handleClose={handlePaymentClose}
            id={SelectedId}
            handleAlertOpen={props.handleAlertOpen}
            handleGet={props.handleGet}
          />
          <Grid container>
            <Grid item xs={12} sx={{ minHeight: 400 }}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500, minHeight: 100 }} aria-label="simple table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>DS Name</TableCell>
                      <TableCell align="left">Mobile Number</TableCell>
                      <TableCell align="left">Email</TableCell>
                      <TableCell align="left">State</TableCell>
                      <TableCell align="left">District</TableCell>
                      <TableCell align="left">Type of ds</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Remarks</TableCell>
                      <TableCell align="left">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data &&
                      props.data.all_gm_updated_ds &&
                      props.data.all_gm_updated_ds.map((row) => (
                        <TableRow key={row.user_id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell component="th" scope="row">
                            {row.distributor_name}
                          </TableCell>
                          <TableCell align="left">{row.mobile_number_1}</TableCell>
                          <TableCell align="left">{row.email_address}</TableCell>
                          <TableCell align="left">{row.home_state}</TableCell>
                          <TableCell align="left">{row.home_district}</TableCell>
                          <TableCell align="left">{row.user_type}</TableCell>
                          <TableCell align="left">
                            <Button
                              // disabled={row.payment_link_generate ? false : true}
                              disabled={row.cc_payment_status==='Successful'}
                              variant="outlined"
                              size="small"
                              color="secondary"
                              onClick={() => CheckPaymentStatus(row.user_id)}
                            >
                              check status
                            </Button>
                          </TableCell>
                          <TableCell align="left">
                            <Button variant="outlined" color="primary" size="small" onClick={() => handleOpenReview(row)}>
                              View
                            </Button>
                          </TableCell>
                          <TableCell align="left">
                            <Button
                              // disabled={row.payment_link_generate}
                              disabled={row.cc_payment_status==='Successful'}
                              variant="contained"
                              color="secondary"
                              size="small"
                              onClick={() => handlePaymentOpen(row)}
                            >
                              send link
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              <TablePagination
                component="div"
                count={props.data?.total_count ?? 0} // Fallback to 0 if undefined
                page={props.data?.page - 1 ?? 0} // Default page to 0
                onPageChange={props.handlePageChange}
                rowsPerPage={10}
                rowsPerPageOptions={[10]}
                onRowsPerPageChange={() => {}} // No-op function to prevent warnings
              />
            </Grid>
          </Grid>
        </MainCard>
      </Grid>
    </Grid>
  );
};

export default DsPaymentLinkTable;
